import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Notification } from "./use-fetch-notifications-query";
import { httpRequest } from "@/lib";
import { useNotificationIdentity } from "./use-notification-identity";

type NotificationResponse = Notification;

async function updateNotifications(id: string): Promise<NotificationResponse> {
  const response = await httpRequest.post<NotificationResponse>(
    `/notifications/mark-as-read/${id}`
  );
  return response.data;
}

export function useUpdateNotificationMutation() {
  const queryClient = useQueryClient();
  const { tenantId, userId } = useNotificationIdentity();
  return useMutation({
    mutationFn: updateNotifications,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications", tenantId, userId] });
    },
  });
}
